import { createContext } from "react";

export const ShopReceiptPrinterContext = createContext(null);
